import { jsxs as s, jsx as a } from "react/jsx-runtime";
import { useMasterData as c } from "@nextgen-web-framework/all";
import g from "../footerNavigation/FooterNavigation.js";
import p from "../legalLink/LegalLink.js";
import f from "../socialIcon/SocialIcon.js";
import D from "../FooterLanguage/FooterLanguage.js";
const F = ({
  footer: o,
  hideFooterNavigation: e,
  hideLegalLink: i,
  hideSocialIcon: n,
  langHandler: l,
  locale: m
}) => {
  var r;
  const t = c("WebshopConfigs");
  return /* @__PURE__ */ s("div", { children: [
    !e && /* @__PURE__ */ a(g, { footerData: o.footerData, helpingData: o.helpingData }),
    !n && /* @__PURE__ */ a(f, { socialIcon: o.footerIcon }),
    ((r = t == null ? void 0 : t.locales) == null ? void 0 : r.length) > 1 && /* @__PURE__ */ a(D, { langHandler: l, locale: m }),
    !i && /* @__PURE__ */ a(p, { legalLink: o.legalLink })
  ] });
};
export {
  F as default
};
//# sourceMappingURL=Footer.js.map
